function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 7.095a.455.455 0 01.603-.438L9.82 9.392a.456.456 0 01.31.429v12.316a.456.456 0 01-.602.429L1.365 19.73a.456.456 0 01-.31-.428L1 7.095zm11.87 15.088a.455.455 0 00.611.428L21.7 19.74a.457.457 0 00.301-.428V7.168a.454.454 0 00-.593-.438l-8.218 2.608a.457.457 0 00-.32.437v12.408zM11.364 7.323c.08.022.166.022.246 0l7.926-2.17a.457.457 0 100-.912L11.61 2.017a.457.457 0 00-.246 0L3.548 4.114a.457.457 0 100 .911l7.816 2.298z",
  fill: "#000"
}));